'use client';

import dynamic from 'next/dynamic';

// Dynamically import heavy components to reduce initial JS bundle size
export const DynamicCartModal = dynamic(() => import('@/components/cart/modal'), {
  ssr: false,
  loading: () => <div className="h-10 w-10 animate-pulse rounded-md bg-neutral-800"></div>
});

export const DynamicAccountModal = dynamic(() => import('@/components/customer/account-modal'), {
  ssr: false,
  loading: () => <div className="h-10 w-10 animate-pulse rounded-md bg-neutral-800"></div>
});
